const LOGO_BLUE = "#4C82E8";
const LOGO_MUTED_BLUE = "#2F5F9F";
const PROP_LAKE_BLUE = "#1769E0";
const PROP_LAKE_WATER = "#72E1E8";
const SEOUL_ARCHDIOCESE_PURPLE = "#6F2C3F";

/** PropLake 서비스 로고 — 부동산 데이터레이크 아이콘 */
export const Logo = ({ size = 34, variant = "proplake" }) => {
  if (variant === "proplake") {
    return <PropLakeLogo size={size} />;
  }

  if (variant === "legacy") {
    return <LogoGridFourBoxes size={size} />;
  }

  if (variant === "single") {
    return <LogoGridSingleBox size={size} />;
  }

  if (variant === "catholic-roof") {
    return <LogoGridCatholicRoof size={size} />;
  }

  return <LogoGridCatholicRoofMutedBlue size={size} />;
};

/** PropLake 기본 심볼: 집 지붕과 호수의 물결을 하나의 간결한 표식으로 결합한다. */
export const PropLakeLogo = ({ size = 34 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="24" y="24" width="208" height="208" rx="54" fill={PROP_LAKE_BLUE} />
      <path
        d="M68 120L128 70L188 120"
        stroke="#FFFFFF"
        strokeWidth="18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78 113V138M178 113V138"
        stroke="#FFFFFF"
        strokeWidth="18"
        strokeLinecap="round"
      />
      <path
        d="M58 149C82 130 105 130 128 149C151 168 174 168 198 149"
        stroke="#FFFFFF"
        strokeWidth="18"
        strokeLinecap="round"
      />
      <path
        d="M72 184C91 171 109 171 128 184C147 197 165 197 184 184"
        stroke={PROP_LAKE_WATER}
        strokeWidth="14"
        strokeLinecap="round"
      />
    </svg>
  );
};

/** 집보Go 서비스 로고 후보 — 서울대교구 주색 지붕 + 차분한 파란 본체 아이콘 */
export const LogoGridCatholicRoofMutedBlue = ({ size = 34 }) => {
  return (
    <LogoGridHouse
      size={size}
      roofColor={SEOUL_ARCHDIOCESE_PURPLE}
      bodyColor={LOGO_MUTED_BLUE}
    />
  );
};

/** 집보Go 서비스 로고 후보 — 서울대교구 주색 지붕 + 기존 파란 본체 아이콘 */
export const LogoGridCatholicRoof = ({ size = 34 }) => {
  return (
    <LogoGridHouse
      size={size}
      roofColor={SEOUL_ARCHDIOCESE_PURPLE}
      bodyColor={LOGO_BLUE}
    />
  );
};

/** 집보Go 서비스 로고 후보 — 단색 집 아이콘 */
export const LogoGridSingleBox = ({ size = 34 }) => {
  return (
    <LogoGridHouse
      size={size}
      roofColor={LOGO_BLUE}
      bodyColor={LOGO_BLUE}
    />
  );
};

/** 집보Go 집 로고 기본 도형 */
const LogoGridHouse = ({
  size = 34,
  roofColor = LOGO_BLUE,
  bodyColor = LOGO_BLUE,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={roofColor}
        d="
          M128 18
          C133 18 138 20 143 24
          L224 80
          C228 83 229 88 227 92
          C225 96 221 98 216 98
          H206
          H50
          H40
          C35 98 31 96 29 92
          C27 88 28 83 32 80
          L113 24
          C118 20 123 18 128 18
          Z
        "
      />
      {/* 집 본체에서 2x2 내부 창을 같은 비율의 둥근 사각형으로 비워낸다. */}
      <path
        fill={bodyColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="
          M50 92
          H206
          V194
          C206 210 194 222 178 222
          H78
          C62 222 50 210 50 194
          V92
          Z

          M76 96
          H108
          C116 96 122 102 122 110
          V132
          C122 140 116 146 108 146
          H76
          C68 146 62 140 62 132
          V110
          C62 102 68 96 76 96
          Z

          M148 96
          H180
          C188 96 194 102 194 110
          V132
          C194 140 188 146 180 146
          H148
          C140 146 134 140 134 132
          V110
          C134 102 140 96 148 96
          Z

          M76 158
          H108
          C116 158 122 164 122 172
          V194
          C122 202 116 208 108 208
          H76
          C68 208 62 202 62 194
          V172
          C62 164 68 158 76 158
          Z

          M148 158
          H180
          C188 158 194 164 194 172
          V194
          C194 202 188 208 180 208
          H148
          C140 208 134 202 134 194
          V172
          C134 164 140 158 148 158
          Z
        "
      />
      <rect
        x="62"
        y="116"
        width="60"
        height="10"
        rx="5"
        fill={bodyColor}
      />
    </svg>
  );
};

/** 집보Go 서비스 로고 후보 — 기존 단일 path 아이콘 */
export const LogoGridSinglePath = ({ size = 34 }) => {
  return <LogoGridCatholicRoof size={size} />;
};

/** 집보Go 서비스 로고 후보 — 4개 독립 박스 아이콘 */
export const LogoGridFourBoxes = ({ size = 34 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={LOGO_BLUE}
        strokeWidth={12}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect
          x="40"
          y="40"
          width="82"
          height="82"
          rx="14"
        />
        <line
          x1="40"
          y1="81"
          x2="122"
          y2="81"
        />
        <rect
          x="131"
          y="40"
          width="82"
          height="82"
          rx="14"
        />
        <rect
          x="40"
          y="131"
          width="82"
          height="82"
          rx="14"
        />
        <rect
          x="131"
          y="131"
          width="82"
          height="82"
          rx="14"
        />
      </g>
    </svg>
  );
};
